import { render } from "./UrlDataStoreView.vue?vue&type=template&id=d5493bec&scoped=true"
import script from "./UrlDataStoreView.vue?vue&type=script&lang=js"
export * from "./UrlDataStoreView.vue?vue&type=script&lang=js"

import "./UrlDataStoreView.vue?vue&type=style&index=0&id=d5493bec&scoped=true&lang=css"

import exportComponent from "E:\\project\\spiderx-gui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5493bec"]])

export default __exports__